import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { filter, map, withLatestFrom } from 'rxjs/operators';
import AppState from '../../state';
import { hasActiveSubscription } from '../selectors';
import { CloseMenu } from '../../ui/action-creators';
import { ListSubscriptionsSuccess } from '../action-creators';
import { LIST_SUBSCRIPTIONS_SUCCESS } from '../actions';

export const hideUpgradeIfSubscribedEpic = (
  action$: Observable<ListSubscriptionsSuccess>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<ListSubscriptionsSuccess>(LIST_SUBSCRIPTIONS_SUCCESS),
    withLatestFrom(state$),
    filter(
      ([, state]) =>
        hasActiveSubscription(state) &&
        state.ui.menuOpened === 'DISTRIBUTION_TRIAL'
    ),
    map(() => new CloseMenu(undefined, true))
  );
